import React from 'react';
import { TextField } from '@mui/material';

const ContactListSearch = ({ handleSearch }) => {
  return (
    <TextField
      fullWidth
      id="outlined-basic"
      placeholder="Search"
      variant="outlined"
      onChange={event => handleSearch(event.target.value)}
    />
  );
};

export default ContactListSearch;
